import React, { useEffect, createElement } from 'react';
export function LandingPage() {
  useEffect(() => {
    // Load Typeform embed script
    const script = document.createElement('script');
    script.src = '//embed.typeform.com/next/embed.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      // Cleanup script on unmount
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);
  return <div className="min-h-screen w-full bg-gradient-to-b from-blue-50 to-white" data-id="element-5">
      <div className="container mx-auto px-4 py-12 max-w-4xl" data-id="element-6">
        <div className="text-center mb-10" data-id="element-7">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6" data-id="element-8">
            Completa este formulario para acceder a tu BONOS gratis una vez que
            completes el masterclass hasta el final de la llamada
          </h1>
          <div className="w-20 h-1 bg-blue-500 mx-auto mb-8" data-id="element-9"></div>
          <p className="text-gray-600 text-lg mb-8" data-id="element-10">
            Por favor llena todos los campos para asegurar que recibas tus bonos
            especiales.
          </p>
        </div>
        <div className="bg-white rounded-lg shadow-lg overflow-hidden" style={{
        height: '500px'
      }} data-id="element-11">
          <div data-tf-live="01KAEY83F1W1CA6FV67A52DD6Q" style={{
          height: '100%'
        }} data-id="element-12"></div>
        </div>
        <div className="mt-8 text-center text-sm text-gray-500" data-id="element-13">
          <p data-id="element-14">
            Tu información está segura y nunca será compartida con terceros.
          </p>
        </div>
      </div>
    </div>;
}